export enum Job {
    Realtor = 'Realtor',
    ProxyAgent = 'ProxyAgent',
    Syndic = 'Syndic',
    Insurer = 'Insurer',
    Banker = 'Banker',
    AssetAdvisor = 'AssetAdvisor',
    Broker = 'Broker',
    Diagnoser = 'Diagnoser',
    RealEstateExpert = 'RealEstateExpert',
    Institutionnal = 'Institutional',
    Notary = 'Notary',
    Developer = 'Developer',
    Other = 'Other',
}
